angular.module('internal.vehiclebookings').directive('vehicleProcedureLine', function () {
    return {
        restrict: 'E',
        templateUrl: 'js/internal/vehiclebookings/directives/vehicle-procedure-line/vehicle-procedure-line.html',
        controllerAs: 'vm',
        // replace: true,
        scope: {
            line: '=',
            editable: "=",
            form: "="
        },
    };
});